import React from 'react';
import Router from './Router';
import GlobalModule from './components/Modules/GlobalModule';
import 'leaflet/dist/leaflet.css';
import './App.css';

const App = () => {
  return (
    <GlobalModule>
      <Router />
    </GlobalModule>
  )
}

export default App